import { render } from "./Socials.vue?vue&type=template&id=2a61a4d8&scoped=true"
import script from "./Socials.vue?vue&type=script&lang=js"
export * from "./Socials.vue?vue&type=script&lang=js"

import "./Socials.vue?vue&type=style&index=0&id=2a61a4d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a61a4d8"

export default script